import Http, { ApiRootType } from '../Http/Http'
import {
    CatalogResponseDTO,
    ChannelSettingsDTO,
    CompanyChildDTO,
    CompanyDTO,
    CompanyIdDTO,
    createUserRequestDTO,
    ResetPwdDTO,
    RoleDTO,
    SiteResponseDTO,
    UserDTO,
    UserResponseDTO
} from './ManagementModel'

const http = new Http()
export class ManagementService {
    async getCompanies(): Promise<CompanyDTO[]> {
        try {
            const response = await http.sendGet<CompanyDTO[]>('api/client/companies', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getCompanyById(companyId: string): Promise<CompanyIdDTO> {
        try {
            const response = await http.sendGet<CompanyIdDTO>(`api/client/companies/${companyId}`, undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getCompaniesChildren(): Promise<CompanyChildDTO[]> {
        try {
            const response = await http.sendGet<CompanyChildDTO[]>('api/client/companies/children', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getUser(): Promise<UserDTO[]> {
        try {
            const response = await http.sendGet<UserDTO[]>('api/client/users', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async postUser(data: createUserRequestDTO): Promise<UserResponseDTO> {
        try {
            const response = await http.post<UserResponseDTO>('api/client/users', data, {}, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async putUser(userId: string, data: createUserRequestDTO): Promise<UserResponseDTO> {
        try {
            const response = await http.put<UserResponseDTO>(`api/client/users/${userId}`, data, 6000, undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async deleteUser(userId: string): Promise<void> {
        try {
            await http.delete(`api/client/users/${userId}`, 6000, ApiRootType.two)
        } catch (e) {
            throw e
        }
    }
    async getUserExport(format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>('client/users/export', { params: { format }, downloadFilename: `users.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getSite(): Promise<SiteResponseDTO[]> {
        try {
            const response = await http.sendGet<SiteResponseDTO[]>('api/client/sites', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getSiteExport(format: 'CSV' | 'XLSX', societeId?: string): Promise<void> {
        try {
            await http.get<Blob>(
                'client/sites/export',
                { params: societeId ? { societeId } : {}, downloadFilename: `sites.${format}` },
                ApiRootType.one
            )
        } catch (e) {
            throw e
        }
    }
    async getSiteExportById(siteId: string, format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>(`client/sites/${siteId}/zones/export`, { downloadFilename: `site.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getCatalog(): Promise<CatalogResponseDTO[]> {
        try {
            const response = await http.sendGet<CatalogResponseDTO[]>('api/client/catalogs', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async putCatalog(catalogId: string, data: ChannelSettingsDTO): Promise<CatalogResponseDTO> {
        try {
            const response = await http.put<CatalogResponseDTO>(
                `api/client/catalogs/${catalogId}/channels`,
                data,
                6000,
                undefined,
                ApiRootType.two
            )
            return response.data
        } catch (e) {
            throw e
        }
    }

    async getCatalogExportId(catalogId: string, format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>(`client/catalogs/${catalogId}/export`, { downloadFilename: `catalog.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getCatalogExport(format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>('client/catalogs/export', { downloadFilename: `catalogs.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getRole(): Promise<RoleDTO[]> {
        try {
            const response = await http.sendGet<RoleDTO[]>('api/roles', undefined, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async resetPwd(email: string): Promise<ResetPwdDTO> {
        try {
            const response = await http.post<ResetPwdDTO>('api/auth/recover', { email }, {}, ApiRootType.two)
            return response.data
        } catch (e) {
            throw e
        }
    }
}
